import React from 'react';
import { Link } from 'react-router-dom';
import { BLOG_CFG } from '../data/blogConfig';
import { PILLARS } from '../data/editorial';
const FR_POSTS = BLOG_CFG.fr.posts;
import CursiveTool from '../components/tool/CursiveTool';
import Faq from '../components/Faq';
import StylePreviewCard, { sample, C } from '../components/StylePreviewCard';
import { PageHero, HowToSteps } from './Home';
import { T, ES_FAQ, ID_FAQ, FR_FAQ } from '../data/i18n';

const FR = {
  whatTitle: "Qu'est-ce que l'écriture cursive en ligne ?",
  what: [
    "Ce générateur remplace chaque lettre par un symbole Unicode qui ressemble à de l'écriture manuscrite. Aucune police à installer : il suffit de copier puis coller.",
    "Le résultat fonctionne sur Instagram, TikTok, WhatsApp, Discord, dans vos e-mails et dans presque toutes les applications qui acceptent du texte.",
  ],
  usesTitle: 'Idées d’utilisation',
  uses: ['Bio et nom Instagram', 'Pseudo TikTok ou Discord', 'Faire-part de mariage', 'Signature d’e-mail', 'Inspiration pour un tatouage', 'Cartes de vœux et étiquettes cadeaux'],
  faq: FR_FAQ,
};

const COPY = {
  es: {
    whatTitle: '¿Qué son las letras cursivas?',
    what: [
      'Las letras cursivas de esta herramienta son símbolos Unicode que imitan la escritura a mano. No necesitas instalar ninguna fuente: basta con copiar y pegar.',
      'Funcionan en Instagram, TikTok, WhatsApp, Discord y casi cualquier aplicación que acepte texto.',
    ],
    usesTitle: 'Usos populares',
    uses: ['Biografías de Instagram', 'Nombres en TikTok', 'Invitaciones de boda', 'Firmas de correo', 'Ideas para tatuajes'],
    faq: ES_FAQ,
  },
  id: {
    whatTitle: 'Apa itu Tulisan Keren?',
    what: [
      'Tulisan keren di sini adalah simbol Unicode yang menyerupai tulisan tangan. Tidak perlu memasang font apa pun, cukup salin dan tempel.',
      'Hasilnya bisa dipakai di Instagram, TikTok, WhatsApp, Discord, dan hampir semua aplikasi.',
    ],
    usesTitle: 'Kegunaan populer',
    uses: ['Bio Instagram', 'Nama TikTok', 'Undangan pernikahan', 'Tanda tangan email', 'Ide tato'],
    faq: ID_FAQ,
  },
};

export default function LocalizedHome({ lang }) {
  const t = T[lang];
  const c = lang === 'fr' ? FR : COPY[lang];
  return (
    <div data-testid={`home-${lang}`}>
      <PageHero t={t} />
      <div className="px-4"><CursiveTool t={t} /></div>
      <HowToSteps t={t} />
      {lang === 'fr' && <nav aria-label="Choisir un usage" className="content-narrow flex flex-wrap gap-3 pt-8">{PILLARS.map(p => <Link key={p.id} className="pill-btn" to={p.path}>{p.title}</Link>)}</nav>}
      <section className="content-narrow py-12 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <div className="prose-site">
          <h2 className="!mt-0">{c.whatTitle}</h2>
          {c.what.map((p) => <p key={p}>{p}</p>)}
          <h3>{c.usesTitle}</h3>
          <ul>{c.uses.map((u) => <li key={u}>{u}</li>)}</ul>
        </div>
        <StylePreviewCard title={t.preview} rows={[
          [t.filters.cursive, sample(C.boldScript, t.sample + ' ' + t.sample)],
          [t.filters.bold, sample(C.boldItalic, t.sample + ' ' + t.sample)],
          [t.filters.gothic, sample(C.fraktur, t.sample + ' ' + t.sample)],
          [t.filters.special, sample(C.doubleStruck, t.sample + ' ' + t.sample)],
        ]} />
      </section>
      {lang === 'fr' && (
        <section className="content-narrow pb-12" data-testid="fr-blog-teaser">
          <div className="flex items-end justify-between mb-5">
            <h2 className="text-[26px] font-bold text-[var(--ink)]">Derniers articles du blog</h2>
            <Link to="/fr/blog" className="text-[14px] text-[var(--brand)] hover:underline" data-testid="fr-blog-all">Voir tous les articles »</Link>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {FR_POSTS.slice(0, 3).map((p) => (
              <Link key={p.slug} to={`/fr/blog/${p.slug}`} className="blog-card group" data-testid={`fr-teaser-${p.slug}`}>
                <div className="aspect-[3/2] overflow-hidden"><img src={p.img} alt={p.imgAlt} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" /></div>
                <div className="p-4"><span className="text-[12px] text-[var(--brand)]">{p.cat}</span><h3 className="text-[16px] font-bold text-[var(--ink)] leading-snug mt-1 group-hover:text-[var(--brand)] transition-colors">{p.title}</h3></div>
              </Link>
            ))}
          </div>
          <Link to="/fr/generateur-bio-instagram" className="flex items-center justify-between gap-4 rounded-lg bg-[var(--brand-soft)] border border-[var(--line)] px-5 py-4 mt-8 transition-transform duration-300 hover:-translate-y-0.5" data-testid="fr-bio-promo">
            <span><b className="text-slate-800">Nouveau : Générateur de bio Instagram</b><br /><span className="text-[14px] text-slate-600">Des modèles de bio en français, prêts à remplir avec votre prénom en cursive.</span></span>
            <span className="btn-gold !text-white shrink-0">Essayer</span>
          </Link>
        </section>
      )}
      <Faq items={c.faq} title={t.faqTitle} />
    </div>
  );
}
